import { Theme, ThemedStyles } from 'ui/base/theme';

import baseStyles from '../issue_item.module.css';

import fieldTypeIconImageAddressDaylight from '../../../assets/field_types/address/light.png';
import fieldTypeIconImageAddressMidnight from '../../../assets/field_types/address/dark.png';
import fieldTypeIconImageDomainDaylight from '../../../assets/field_types/domain/light.png';
import fieldTypeIconImageDomainMidnight from '../../../assets/field_types/domain/dark.png';
import fieldTypeIconImageFamilyDaylight from '../../../assets/field_types/family/light.png';
import fieldTypeIconImageFamilyMidnight from '../../../assets/field_types/family/dark.png';

export type IssueItemPartialStyles = {
  field: string;
  fieldIcon: string;
  fieldTextLeft: string;
  fieldTextRight: string;
  fieldInfo: string;
  filler: string;
};

export const issueItemPartialThemedStyles: ThemedStyles<IssueItemPartialStyles> = {
  [Theme.DAYLIGHT]: {
    field: baseStyles.field,
    fieldIcon: baseStyles.fieldIcon,
    fieldTextLeft: baseStyles.fieldTextLeft,
    fieldTextRight: baseStyles.fieldTextRight,
    fieldInfo: baseStyles.fieldInfo,
    filler: baseStyles.daylightFiller,
  },
  [Theme.MIDNIGHT]: {
    field: baseStyles.field,
    fieldIcon: baseStyles.fieldIcon,
    fieldTextLeft: baseStyles.fieldTextLeft,
    fieldTextRight: baseStyles.fieldTextRight,
    fieldInfo: baseStyles.fieldInfo,
    filler: baseStyles.midnightFiller,
  },
};

export type IssueItemFieldIconPartialStyles = {
  address: string;
  domain: string;
  family: string;
};

export const themedFieldIconImageStyles: ThemedStyles<IssueItemFieldIconPartialStyles> = {
  [Theme.DAYLIGHT]: {
    address: fieldTypeIconImageAddressDaylight,
    domain: fieldTypeIconImageDomainDaylight,
    family: fieldTypeIconImageFamilyDaylight,
  },
  [Theme.MIDNIGHT]: {
    address: fieldTypeIconImageAddressMidnight,
    domain: fieldTypeIconImageDomainMidnight,
    family: fieldTypeIconImageFamilyMidnight,
  },
};
